<script lang="ts">
    import type {ComponentSize, Px} from '../types';
    import {AutocompleteController} from './utils';
    import AutocompleteResultList from './AutocompleteResultList.svelte';

    export let search: (_: string) => any[] | Promise<any[]>;
    export let currentInputValue = '';
    export let debounce = 0;
    export let getResultValue: (_: any) => string = (result) => result.toString();
    export let size: ComponentSize = 'md';
    export let topOffset: Px | null = null;
    export let additionalContainerClasses = '';

    const autocompleteController = new AutocompleteController(search, currentInputValue, debounce, getResultValue);

    let dropdownElement: HTMLDivElement;
    $: autocompleteController.updateCurrentInputValue(currentInputValue);
</script>

<div class="dropdown {additionalContainerClasses}" bind:this={dropdownElement}>
    <slot {autocompleteController}></slot>

    {#if dropdownElement}
        <AutocompleteResultList {autocompleteController} {size} {topOffset} anchorElement={dropdownElement}/>
    {/if}
</div>